import React from 'react';
import './TermsOfService.css';

const TermsOfService: React.FC = () => {
  return (
    <div className="terms-page">
      <div className="terms-container">
        <header className="terms-header">
          <h1>Terms of Service / AOMTrading, LLC</h1>
          <p><strong>Effective Date:</strong> February 1, 2025</p>
          <p><strong>Company:</strong> AOMTrading, LLC (“AOMTrading,” “we,” “our,” or “us”)</p>
          <p><strong>Website:</strong> <a href="https://www.aomtrading.com" target="_blank" rel="noopener noreferrer">www.aomtrading.com</a></p>
        </header>

        <section>
          <h2>1. ACCEPTANCE OF TERMS</h2>
          <p>
            By accessing or using the AOMTrading website, platform, services, or subscriptions (collectively, the “Services”),
            you agree to be bound by these Terms of Service (“Terms”). If you do not agree, you may not use the Services.
          </p>
        </section>

        <section>
          <h2>2. RIGHTS TO MODIFY</h2>
          <p>We reserve the right, at our sole discretion, to modify or replace these
          terms at any time. By continuing to access or use our website, products,
          services after any revisions become effective, you agree to be bound by
          the revised terms.
          </p>
        </section>

        <section>
          <h2>3. PRIVACY POLICY</h2>
          <p>You agree to our privacy policy as disclosed below:</p>
          <p>1) OUR MISSION</p>
          <p>We are AOMTrading LLC, a vendor that provides trading software and educational services for NinjaTrader users. Our website address is aomtrading.com</p>
          <p>2) CONTACT INFORMATION</p>
          <p>We can be reached at https://aomtrading.com/contact</p>
          <p>3) PRODUCT DATA COLLECTION</p>
          <p>Our software product and educational services don’t collect any user data. We do collect data if you purchase our products.</p>
        </section>

        <section>
          <h2>4. WHAT DATA WE COLLECT</h2>
          <p>If you purchase our products, we collect the following data:</p>
          <ul>
            <li>Email</li>
            <li>Name</li>
            <li>Machine IDs</li>
            <li>Phone Number</li>
          </ul>
        </section>

        <section>
          <h2>5. CONSENT TO COLLECT DATA</h2>
          <p>We collect data from users who purchase our products.</p>
          <p>Subscribers to our Educational and Software Services: We ask for consent during the checkout process.</p>
          <p>The legal basis for us to collect data is to be able to provide products support and services.</p>
        </section>

        <section>
          <h2>6. YOUR RIGHTS</h2>
          <p>You can request a copy of your data which we will provide within 10 days. You can request your data to be anonymized or deleted which we will do within 30 days.</p>
          <p>While we will do everything to keep your data secure, in the event of a data breach or misuse, we will inform you of what happened and what we have done to put it right within 30 days.</p>
        </section>

        <section>
          <h2>7. DATA STORAGE and DATA RETENTION</h2>
          <p>We rely on third-party services to maintain our own services:</p>
          <ul>
            <li>Mailgun</li>
            <li>Stripe</li>
            <li>NetLicensing</li>
          </ul>
          <p>We NEVER share or resell any part of your personal data.</p>
          <p>We will keep identifiable data for an undetermined amount of time or until a user asks us to anonymize and/or delete his/her data.</p>
          <p>Our staff access data solely to deliver services.</p>
          <p>No personal identifiable data is stored on staff computers on a permanent basis.</p>
        </section>

        <section>
          <h2>8. SOFTWARE PURCHASER RIGHTS</h2>
          <p>By purchasing our software license, you are granted the following rights that you must strictly follow.</p>
          <p>You are ALLOWED to:</p>
          <li>Use the software personally on no more than the number of computers permitted by your license.</li>
          <li>Activate the software only on your own computers (NOT other people’s computers). Please note that a multiple-computer license is intended for multiple computers of one person. The only exception is that you can activate the software on your developer’s computer for a temporary use in development.</li>
          <p></p>
          <p>You are FORBIDDEN to:</p>
          <li>Use the software on more than the number of computers permitted by your license.</li>
          <li>Resell or transfer your license to other parties.</li>
          <li>Give the software away for free (e.g. via websites, forums, social networks, emails).</li>
          <li>Resell, rent or include the software in your commercial products/services.</li>
          <li>Reproduce the software, that is, make one or more copies of the software, except when the copy of the software is reproduced in accordance with these terms.</li>
          <li>Modify the software, including but not limited to the implementation of changes into the object codes of the software.</li>
          <li>Disassemble, decompile, reverse-engineer the software (to transform object codes into source codes).</li>
        </section>

        <section>
          <h2>9. REFUND POLICY</h2>
          <p>
            Due to the ease with which software products may be copied and stored, 
            <strong>we will NOT issue refunds of any kind.</strong><br/>
            Our educational services are also non-refundable.
          </p>

          <p>
            Immediately upon signing up for an account or other periodic fee-based 
            services on the Site, the fees for the first period or term of your selected 
            account or service (monthly, quarterly, annual, as applicable) will be charged 
            to your credit card.
          </p>

          <p>
            Within ten (10) business days prior to the expiration of the initially selected 
            period or term, and each subsequent period or term until your account or service 
            is cancelled in accordance with these Terms and Conditions, the fees associated 
            with your selected account or service will be automatically renewed. The renewal 
            amount will be billed and charged to your credit card by AOMTrading, LLC in 
            accordance with the Site’s then-current pricing schedule.
          </p>

          <p>
            If the credit card associated with your account should expire, terminate, or any 
            payment is otherwise rejected by the issuing company, AOMTrading, LLC may 
            immediately terminate your account or service.
          </p>

          <p>
            It is solely your responsibility to ensure: <br/>
            (1) That valid credit card information remains on file for your account and its 
            automatic renewal. <br/>
            (2) That a valid email address remains on file for your account for any communications from AOMTrading, LLC.
          </p>

          <p>
            All payments made to AOMTrading, LLC in connection with any product purchased 
            or account or service, and any renewal thereof, are <strong>non-refundable</strong>. 
            AOMTrading, LLC does not offer, and is not required to provide, any refunds or 
            credits for any reason, including (without limitation) dissatisfaction or failure 
            to cancel your account prior to automatic renewal.
          </p>

          <p>
            <strong>ALL SALES ARE FINAL &amp; NON-REFUNDABLE!</strong>
          </p>

          <p>Therefore, please contact us if you want to ask questions before
          making a purchase.</p>
        </section>

        <section>
          <h2>10. PURCHASES VALIDATION</h2>
          <p>
            If you wish to purchase our products, you may be asked to provide certain 
            information relevant to your purchase including, without limitation: your 
            debit/credit card number, expiration date, name, email, and billing address.
          </p>

          <p>You represent and warrant that:</p>
          <ul>
            <li>You have the legal right to use the debit/credit cards or other payment methods in connection with your purchases.</li>
            <li>The information you provide is true, accurate, and complete.</li>
          </ul>

          <p>
            We may use third-party services to facilitate payments and the completion of purchases. 
            By submitting your information, you grant us the right to provide the information 
            to these third parties.
          </p>
        </section>

        <section>
          <h2>11. ACCOUNTS</h2>
          <p>
            When you create an account with us, you guarantee that you are not under 
            the age of 18, and that the information you provide is accurate, complete, 
            and current at all times. Inaccurate, incomplete, or outdated information 
            may result in the immediate termination of your account.
          </p>

          <p>
            You are responsible for maintaining the confidentiality of your account and 
            password, including (but not limited to) restricting access to your computer 
            and/or account. You agree to accept responsibility for any and all activities 
            that occur under your account and/or password.
          </p>

          <p>
            You must notify us immediately if you become aware of any breach of security 
            or unauthorized use of your account.
          </p>

          <p>Your username must follow these rules:</p>
          <ul>
            <li>You may not use the name of another person or entity without proper authorization.</li>
            <li>You may not use a name or trademark subject to the rights of another person or entity other than yourself.</li>
            <li>You may not use any name that is offensive, vulgar, or obscene.</li>
          </ul>

          <p>
            We reserve the right to refuse service, terminate accounts, remove or edit 
            content, or cancel orders at our sole discretion.
          </p>
        </section>

        <section>
          <h2>12. INTELLECTUAL PROPERTY</h2>
          <p>Our website, products, services and their original content, features and functionality are and will remain our exclusive property. Our trademarks and trade dress may not be used in connection with any products or services without the prior written consent by us.</p>
        </section>

        <section>
          <h2>13. THIRD PARTY</h2>
          <p>Our website and products may contain links to third-party websites that are not owned or controlled by us.</p>

          <p>
            We have no control over, and assume no responsibility for, the content, terms, policies, or practices of any third-party websites. 
            We do not warrant the offerings provided by or listed on any third-party websites.
          </p>

          <p>
            You acknowledge and agree that we shall not be responsible or liable, directly or indirectly, 
            for any damage or loss caused by or in connection with the use of, or reliance on, any such content, 
            goods, or services available on or through any third-party websites.
          </p>

          <p>
            We strongly advise you to carefully read the terms, conditions, and policies of any third-party websites that you visit.
          </p>
        </section>

        <section>
          <h2>14. TERMINATION</h2>
          <p>
            We may terminate or suspend your account and restrict your access to our website, 
            products, and services immediately, without prior notice or liability, at our sole 
            discretion, for any reason deemed satisfactory, including (but not limited to) your 
            breach of these Terms and Conditions.
          </p>
        </section>


        <section>
          <h2>15. RISK OF TRADING</h2>
          <p>
            Futures, Stocks, Options and Forex trading contains substantial
            risk and is not for every investor. An investor could potentially
            lose all or more than the initial investment. Risk capital is money
            that can be lost without jeopardizing one’s financial security or
            lifestyle. Only risk capital should be used for trading and only
            those with sufficient risk capital should consider trading. Past
            performance is not necessarily indicative of future results.
          </p>
        </section>

        <section>
          <h2>16. HYPOTHETICAL PERFORMANCE</h2>
          <p>
            Hypothetical performance results have many inherent limitations, some of which are described below. 
            No representation is being made that any account will or is likely to achieve profits or losses similar 
            to those shown. In fact, there are frequently sharp differences between hypothetical performance results 
            and the actual results subsequently achieved by any particular trading program.
          </p>

          <p>
            One of the limitations of hypothetical performance results is that they are generally prepared with 
            the benefit of hindsight. In addition, hypothetical trading does not involve financial risk, and no 
            hypothetical trading record can completely account for the impact of financial risk in actual trading. 
            For example, the ability to withstand losses or to adhere to a particular trading program in spite of 
            trading losses are material points that can adversely affect actual trading results.
          </p>

          <p>
            There are numerous other factors related to the markets in general or to the implementation of any 
            specific trading program which cannot be fully accounted for in the preparation of hypothetical 
            performance results, all of which can adversely affect actual trading results.
          </p>
        </section>

        <section>
          <h2>17. TESTIMONIALS</h2>
          <p>
          Testimonials on our website may not be representative of the
          experience of other users or customers, and do not guarantee
          future performance or success.
          </p>
        </section>

        <section>
          <h2>18. WARRANTY DISCLAIMER AND LIMITATION OF LIABILITY</h2>
          <p>Our software products are provided to you “as is”. We make no
            express or implied warranties or representations with respect to
            our products. We do not warrant that our software will meet your
            needs or be free from errors, or that the operations of the
            software will be uninterrupted.</p><br/>

          <p>In addition, we make no warranties or representations that the
          operation of our website and licensing servers will be
          uninterrupted or error-free, and we will not be liable for the
          consequences of any interruptions or errors. We may change,
          restrict access to, suspend or discontinue our website, licensing
          servers, or any part of them at any time. When you use our
          website or licensing servers, you understand and agree that you
          participate at your own risk.</p><br/>

          <p>In no event shall we be liable to you for damages, business
          interruptions, loss of business or other data or information, claims
          or expenses, consequential or incidental damages, or lost profits
          and lost savings caused by use or related to use of our products,
          as well as for damage caused by possible errors and misprints in
          our products.</p><br/>
          <p>We shall not bear responsibility for failures in the operation of our
          software products in the event that our software is installed on
          machines on which we have not tested the software.</p><br/>
          <p>We shall not bear responsibility for failures in the operation of our
          software products in the event that the technical requirements
          and/or configurations of machines on which the software is used
          are insufficient or incorrect.</p><br/>
          <p>We shall not be liable for failures in the operation of our software
          products in the event that you have third-party software which
          conflicts with our software, which can modify our software
          settings, which may slow down or decrease your machine’s
          performance, lead to a decrease of machine resources available
          for our software, as a result of which the full operation of our
          software becomes impossible.</p><br/>                   
        </section>


        <section>
          <h2>19. Contact Information</h2>
          <p>For questions about these Terms, contact us at:</p>
          <address>
            AOMTrading, LLC<br />
            Email: <a href="mailto:info@aomtrading.com">info@aomtrading.com</a>
          </address>
        </section>
      </div>
    </div>
  );
};

export default TermsOfService;

